// extracted by mini-css-extract-plugin
module.exports = {"bar":"BottomBar_bar__2k42D","tabs":"BottomBar_tabs__2iUgw"};